import React, {FC} from 'react';

import {hexactHIcon} from '../../images/svgIcons';

import './styles.scss';
interface IProduct {
  name: 'Hexomatic' | 'Hexometer' | 'Hexowatch' | 'Hexospark' | 'Hexofy';
  text: string;
  link: string;
  className: string;
}
const Product: FC<IProduct> = ({name, text, link, className}) => (
  <div className={`product-card ${className ? className : ''}`}>
    <div className={`${name.toLocaleLowerCase()}-bg icon-bg`}>{hexactHIcon}</div>
    <div>
      <h6>
        <a href={link} target="_blank" style={{color: '#1C1A22'}}>
          {name}
        </a>
      </h6>
      <p>{text}</p>
    </div>
  </div>
);

export default Product;
